<template>
    <img ref="img" :src="imgSrc" onerror="imgError(this)">
</template>
<script>
    import parse from "url-parse";
    import path from "path";
    export default {
        props: ["src", "defaultPic"],
        computed: {
            gif() {
                let parsed = parse(this.src);
                let ext = path.extname(parsed.pathname);
                return ext.toLowerCase() == ".gif";
            },
            loadingSrc() {
                return "(loading)";
            },
            imgSrc(){
                if(!this.src)
                    return this.defaultPic || require("@/assets/liveRoom.jpg");
                else
                    return this.gif?this.loadingSrc:this.src
            }
        },
        watch: {
            src(v) {
                if(this.replaceingNode && this.replaceingNode.parentNode) {
                    this.replaceingNode.parentNode.replaceChild(this.$refs.img, this.replaceingNode);
                    this.replaceingNode = null;
                }
                if (this.gif) this._loadGif();
            }
        },
        methods: {
            _renderCanvas(img) {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                canvas
                    .getContext("2d")
                    .drawImage(
                        img,
                        0,
                        0,
                        img.width,
                        img.height,
                        0,
                        0,
                        img.width,
                        img.height
                    );

                try {
                    this.$refs.img.src = canvas.toDataURL();
                } catch (e) {
                    //跨域导致无法使用toDataURL，使用 replaceChild 替换成 canvas
                    let src = this.$refs.img;
                    let des = canvas;
                    if (src && src.parentNode) {
                        for (var j = 0, a; (a = src.attributes[j]); j++)
                            des.setAttribute(a.name, a.value);
                        src.parentNode.replaceChild(des, src);
                        this.replaceingNode = des;
                    }
                }
            },
            _loadGif() {
                let img = new Image();
                let renderCanvas = this._renderCanvas;
                img.onload = function() {
                    renderCanvas(img);
                };

                //图片跨域加载，会导致canvas无法输出dataurl，此处避免
                //同时图片需要有允许跨域头才能使用 canvas.toDataURL();
                //ref:https://www.jianshu.com/p/6fe06667b748

                // 使用这个属性： 会导致没有跨域头的跨域链接无法加载
                // 如果不使用这个属性： 会导致 toDataURL 无法使用
                // img.setAttribute("crossOrigin", "Anonymous");

                img.src = this.src;
            },
        },
        mounted() {
            if (this.gif) {
                this._loadGif();
            }
        }
    };
</script>